import styled from 'styled-components';

const CLEVideosResultDiv = styled.div`
  width: 100%;
`;

CLEVideosResultDiv.displayName = 'CLEVideosResultDiv';

export default CLEVideosResultDiv;
